import React, { memo } from 'react';

import classNames from 'classnames/bind';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import styles from './TooltipCoach.module.scss';

const cx = classNames.bind(styles);

const TooltipCoach = (props) => {
	const { children, content, duration = '19', view = false, style = null, useAnimation = false, useStable = false, direction = null, useHover = false } = props;
	const durationStyle = view ? { animationDuration: `${duration}s` } : null;
	const ua = useSsrUserAgent();

	return (
		<div className={cx('wrap_tooltip', { view }, { stable: useStable }, `${direction}`, { hover: useHover && ua().isPc })}>
			{children}
			<div
				className={cx('tooltip')}
				style={durationStyle}
			>
				<div
					className={cx('inner', useAnimation ? 'ani_bounce' : '')}
					style={style}
				>
					{content}
				</div>
			</div>
		</div>
	);
};

export default memo(TooltipCoach);
